import { render, staticRenderFns } from "./dadosDaApi.vue?vue&type=template&id=530c5dcd&"
import script from "./dadosDaApi.vue?vue&type=script&lang=js&"
export * from "./dadosDaApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports